import { IPassportGroup, IPassportSchema, TCreatePassportGroupDTO } from '@/pages/MDM/mdm.types.ts'
import usePassportGroup from '@/pages/MDM/hooks/usePassportGroup.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import mdmApi from '@/pages/MDM/mdm.api.ts'
import mdmEvents from '@/pages/MDM/events/mdm.events.ts'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import Modal from '@/shared/Modal'
import FormField from '@/shared/Forms/FormField'
import PassportGroupDropdown from '@/pages/MDM/components/Passports/PassportGroupDropdown'
import TextInput from '@/shared/Inputs/TextInput'
import SeparateLine from '@/shared/Forms/SeparateLine'
import Button from '@/shared/Buttons/Button'
import { useEffect } from 'react'

interface IProps {
  passportSchemaId: IPassportSchema['id']
  groupId: IPassportGroup['id']

  open: boolean
  onClose: () => void
}

const UpdatePassportGroupModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const prevGroup = usePassportGroup(props.groupId, props.passportSchemaId)
  const [group, setGroup, handleChange] = useStateWithChange<TCreatePassportGroupDTO>(prevGroup)

  useEffect(() => {
    setGroup(prevGroup)
  }, [prevGroup])

  const handleSave = () => {
    wait(mdmApi.updatePassportSchemaGroup(group, props.groupId), (resp) => {
      if (resp.status === 'success') {
        mdmEvents.passportSchemaGroupUpdated(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <Modal title="Обновление группы" onClose={props.onClose} open={props.open} closeOnClickOutside={false}>
      <div className="flex-lines gap16">
        <FormField label="Вышестоящая группа">
          <PassportGroupDropdown
            name="parentId"
            wrapperStyle={{ height: '32px' }}
            onChange={handleChange}
            value={group.parentId}
            passportSchemaId={props.passportSchemaId}
            title="Выберите группу"
          />
        </FormField>
        <FormField label="Наименование группы" required>
          <TextInput name="name" onChange={handleChange} value={group.name} placeHolder="Введите наименование" />
        </FormField>
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Button size="default" type="default" text="Отмена" onClick={props.onClose} disabled={loading} />
          <Button size="default" type="primary" text="Создать" onClick={handleSave} loading={loading} />
        </div>
      </div>
    </Modal>
  )
}

export default (props: IProps) => {
  if (!props.groupId) return null

  return <UpdatePassportGroupModal {...props} />
}
